/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Change_Payment_DetailsInputs */

const en_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const id_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah`)
};

const ms_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukar`)
};

const ca_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canvia`)
};

const cs_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změnit`)
};

const da_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift`)
};

const de_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändern`)
};

const et_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muuda`)
};

const es_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar`)
};

const fr_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const hr_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promijeni`)
};

const it_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia`)
};

const lv_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mainīt`)
};

const lt_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keisti`)
};

const hu_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módosítás`)
};

const nl_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzig`)
};

const nb_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endre`)
};

const pl_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień`)
};

const pt_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar`)
};

const ro_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifică`)
};

const sk_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmeniť`)
};

const sl_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spremeni`)
};

const fi_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda`)
};

const sv_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändra`)
};

const vi_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi`)
};

const tr_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değiştir`)
};

const el_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αλλαγή`)
};

const bg_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промяна`)
};

const ru_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить`)
};

const sr_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промени`)
};

const uk_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змінити`)
};

const ka_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შესაცვლელად`)
};

const hi_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलें`)
};

const th_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยน`)
};

const ko_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경`)
};

const zh_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改`)
};

const zh_tw_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更`)
};

const ja_change_payment_details = /** @type {(inputs: Change_Payment_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

/**
* | output |
* | --- |
* | "Change" |
*
* @param {Change_Payment_DetailsInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const change_payment_details = /** @type {((inputs?: Change_Payment_DetailsInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Change_Payment_DetailsInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_change_payment_details(inputs)
	if (locale === "ms") return ms_change_payment_details(inputs)
	if (locale === "ca") return ca_change_payment_details(inputs)
	if (locale === "cs") return cs_change_payment_details(inputs)
	if (locale === "da") return da_change_payment_details(inputs)
	if (locale === "de") return de_change_payment_details(inputs)
	if (locale === "et") return et_change_payment_details(inputs)
	if (locale === "es") return es_change_payment_details(inputs)
	if (locale === "fr") return fr_change_payment_details(inputs)
	if (locale === "hr") return hr_change_payment_details(inputs)
	if (locale === "it") return it_change_payment_details(inputs)
	if (locale === "lv") return lv_change_payment_details(inputs)
	if (locale === "lt") return lt_change_payment_details(inputs)
	if (locale === "hu") return hu_change_payment_details(inputs)
	if (locale === "nl") return nl_change_payment_details(inputs)
	if (locale === "nb") return nb_change_payment_details(inputs)
	if (locale === "pl") return pl_change_payment_details(inputs)
	if (locale === "pt") return pt_change_payment_details(inputs)
	if (locale === "ro") return ro_change_payment_details(inputs)
	if (locale === "sk") return sk_change_payment_details(inputs)
	if (locale === "sl") return sl_change_payment_details(inputs)
	if (locale === "fi") return fi_change_payment_details(inputs)
	if (locale === "sv") return sv_change_payment_details(inputs)
	if (locale === "vi") return vi_change_payment_details(inputs)
	if (locale === "tr") return tr_change_payment_details(inputs)
	if (locale === "el") return el_change_payment_details(inputs)
	if (locale === "bg") return bg_change_payment_details(inputs)
	if (locale === "ru") return ru_change_payment_details(inputs)
	if (locale === "sr") return sr_change_payment_details(inputs)
	if (locale === "uk") return uk_change_payment_details(inputs)
	if (locale === "ka") return ka_change_payment_details(inputs)
	if (locale === "hi") return hi_change_payment_details(inputs)
	if (locale === "th") return th_change_payment_details(inputs)
	if (locale === "ko") return ko_change_payment_details(inputs)
	if (locale === "zh") return zh_change_payment_details(inputs)
	if (locale === "zh-tw") return zh_tw_change_payment_details(inputs)
	if (locale === "ja") return ja_change_payment_details(inputs)
	return en_change_payment_details(inputs)
});